import { Box, Button, Typography } from "@mui/material";
import { useGetDearProducts } from "@queries/useGetDearProducts";

export default function GetDearProductsButton() {
  const {
    data,
    error,
    isLoading,
    isSuccess,
    isError,
    refetch, // 🔥 manual trigger
  } = useGetDearProducts(["ssp"]);

  const handleClick = () => {
    refetch();
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleClick} variant="contained">
        {isLoading ? "Getting..." : "Get Dear Products"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Success! data: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
